export enum CTA_TEXT {
  GET_STARTED = 'Get started',
}
